import { ChevronDown, ChevronUp } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import useReportsStore from "~/store/reportsSectionStore";

export default function PeriodFilter({ customOnly = false }) {
  const [open, setOpen] = useState(false);
  const { filters, setFilters, periodOptions } = useReportsStore();
  const [selected, setSelected] = useState(filters.period);
  const [startDate, setStartDate] = useState(filters.period.from);
  const [endDate, setEndDate] = useState(filters.period.to);

  useEffect(() => {
    setSelected(filters.period);
    setStartDate(filters.period.from);
    setEndDate(filters.period.to);
  }, [filters.period]);
  const onChangeFrom = (date) => {
    setStartDate(date);
    if (date) {
      const next = {
        ...filters.period,
        label: "Custom",
        from: date,
      };
      if (endDate && endDate < date) next.to = date;
      setFilters({ ...filters, period: next });
      setSelected(next);
    }
  };

  const onChangeTo = (date) => {
    setEndDate(date);
    if (date) {
      const next = {
        ...filters.period,
        label: "Custom",
        to: date,
      };
      if (startDate && startDate > date) next.from = date;
      setFilters({ ...filters, period: next });
      setSelected(next);
    }
  };

  return (
    <div className="flex flex-row justify-start items-start gap-2 h-16">
      {!customOnly && (
        <>
          {open && (
            <div
              onClick={() => setOpen(false)}
              className="fixed top-0 left-0 w-full h-full bg-transparent z-1"
            ></div>
          )}
          <div
            className={`flex flex-col gap-y-2 text-xs bg-zinc-100 rounded p-1 min-h-12 min-w-48 z-10 border ${
              open ? "border-primary shadow-lg" : "border-transparent"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpen(!open)}
              className="flex flex-row justify-between items-center gap-x-2 text-xs cursor-pointer p-1 text-left"
            >
              <div className="flex flex-col">
                <span>Period</span>
                <strong className="text-sm">{selected?.label}</strong>
              </div>
              {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
            {open && (
              <div className="flex flex-col justify-start items-start gap-2 py-1 border-t border-zinc-300 text-zinc-500">
            {(customOnly ? periodOptions : periodOptions.filter((o) => o.label !== "Custom")).map((option, index) => (
              <button
                key={index}
                type="button"
                onClick={() => {
                  setFilters({
                    ...filters,
                    period: option,
                  });
                  setOpen(false);
                  setSelected(option);
                }}
                className="w-full text-left p-1 hover:text-primary hover:bg-zinc-200 rounded-sm cursor-pointer"
              >
                {option?.label}
              </button>
            ))}
              </div>
            )}
          </div>
        </>
      )}
      {(selected?.label === "Custom" || customOnly) && (
        <div className="flex flex-row justify-start items-end gap-3 text-xs p-1">
          <div className="flex flex-col gap-1">
            <span className="text-[11px] text-zinc-600">Period From</span>
            <DatePicker
              selected={startDate}
              onChange={onChangeFrom}
              dateFormat="yyyy-MM-dd"
              className="bg-transparent bg-zinc-50 border text-center border-zinc-200 rounded-sm h-10 px-2 min-w-40"
              placeholderText="yyyy-MM-dd"
            />
          </div>
          <div className="flex flex-col gap-1">
            <span className="text-[11px] text-zinc-600">To</span>
            <DatePicker
              selected={endDate}
              onChange={onChangeTo}
              dateFormat="yyyy-MM-dd"
              className="bg-transparent bg-zinc-50 border text-center border-zinc-200 rounded-sm h-10 px-2 min-w-40"
              placeholderText="yyyy-MM-dd"
            />
          </div>
        </div>
      )}
    </div>
  );
}

function DropdownCard({ label, display, options, onSelect, className = "min-w-48" }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      {open && (
        <div onClick={() => setOpen(false)} className="fixed inset-0 w-full h-full bg-transparent z-10"></div>
      )}
      <div className={`relative z-20 flex flex-col gap-y-2 text-xs bg-zinc-100 rounded p-1 min-h-12 ${className} border ${open ? "border-primary shadow-lg" : "border-transparent"}`}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className="flex flex-row justify-between items-center gap-x-2 text-xs cursor-pointer p-1 text-left"
        >
          <div className="flex flex-col">
            <span>{label}</span>
            <strong className="text-sm">{display}</strong>
          </div>
          {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </button>
        {open && (
          <div className="absolute left-0 top-full mt-1 w-full bg-white border border-zinc-300 rounded shadow-lg max-h-64 overflow-auto">
            {options.map((opt) => (
              <button
                key={opt.key}
                type="button"
                className="w-full text-left p-2 hover:bg-zinc-100"
                onClick={() => {
                  onSelect(opt.key);
                  setOpen(false);
                }}
              >
                {opt.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
